import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function createLeadTasks(body) {

  try {
    return await axios.post(`${REACT_APP_API}/leadtasks`, body)
  } catch (error){
    throw new Error(error?.response?.data?.message || error)
  }

}